import confetti from "canvas-confetti";

const CONFETTI_COLORS = ["#d4f754", "#2cdcec", "#ff4a84", "#ffffff"];

/** True khi user bật prefers-reduced-motion (tắt animation). */
export const prefersReducedMotion = (): boolean =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

/**
 * Bắn confetti từ tâm của một element (vd: nút claim).
 * No-op khi reduced-motion hoặc element không hợp lệ.
 */
export const fireConfettiAt = (el: HTMLElement | null): void => {
  if (!el || prefersReducedMotion()) return;

  const rect = el.getBoundingClientRect();
  const origin = {
    x: (rect.left + rect.width / 2) / window.innerWidth,
    y: (rect.top + rect.height / 2) / window.innerHeight,
  };

  confetti({
    particleCount: 60,
    spread: 70,
    startVelocity: 32,
    gravity: 0.9,
    scalar: 0.9,
    ticks: 120,
    origin,
    colors: CONFETTI_COLORS,
    disableForReducedMotion: true,
  });
};
